import styled from "styled-components";

import { Col, Row } from "antd";

export const ModalRow = styled(Row)`
  display: flex;
  justify-content: center;
`;

export const ModalCol = styled(Col)`
  & .ant-form-item {
    width: 100%;
    height: 100%;
  }
`;
